import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { environment } from '../../../../environments';
import { CacheService } from '../../../ssr-services/cache/cache.service';

export const updateTitleFaviconGuard: CanActivateFn = () => {
  const $document = inject(DOCUMENT);

  const cacheService = inject(CacheService);
  const cacheContent = cacheService.cachedContent();

  if (!cacheContent) {
    console.log('no cache content for favicon');
    return of(true);
  }

  const webAppConfig = cacheContent.cache?.config?.webAppConfig;
  let favicon: string | undefined;

  if (environment.previewMode && webAppConfig?.faviconPreview) {
    favicon = webAppConfig.faviconPreview;
  } else if (webAppConfig?.favicon) {
    favicon = webAppConfig.favicon;
  }

  if (favicon) {
    updateFavicon($document, favicon);
  }

  return true;
};

export function updateFavicon(document: Document, newFavicon: string): void {
  let link = document.querySelector('#favicon') as HTMLLinkElement;

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = newFavicon;
}
